module.exports = __webpack_public_path__ + "static/media/intro-hero-circles.2144d1d8.png";